export default __webpack_public_path__ + "static/media/an5.3ac26597.jpg";